module.exports = __webpack_public_path__ + "static/img/join.47427c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/GreenTreeDetail/join.png
// module id = 1147
// module chunks = 18